import { render } from "./HomeSobreNos.vue?vue&type=template&id=746f0c8b&scoped=true"
import script from "./HomeSobreNos.vue?vue&type=script&lang=js"
export * from "./HomeSobreNos.vue?vue&type=script&lang=js"

import "./HomeSobreNos.vue?vue&type=style&index=0&id=746f0c8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746f0c8b"]])

export default __exports__